import { Directive, TemplateRef } from '@angular/core';

/**
 * Only used to inject templates and know what it is intended to replace
 */
@Directive({ selector: '[ui-popover-template]' })
export class UIPopoverTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
